import PhoneInput from 'react-phone-input-2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PhoneNumberInput.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function PhoneNumberInput({ onChange, phone, disabled = false, error }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm">{t('common.forms.phone')}</label>
      <PhoneInput
        containerClass='flex flex-row-reverse justify-center items-center border-1 rounded border-[#d1d3d4] p-[4px]'
        inputClass="!border-0 !p-0 shadow-none !focus:shadow-none"
        buttonClass="!border-0 !p-[5px] !relative !bg-white"
        value={phone}
        onChange={onChange}
        disabled={disabled}
        enableAreaCodes={true}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
